module.exports = __webpack_public_path__ + "static/img/78.15e43d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/78.png
// module id = CQxt
// module chunks = 1